export enum TradingPartnerType {
  upstream = 'upstream',
  downstream = 'downstream',
  both = 'both',
}

export enum TradingPartnerStatusEnum {
  inactive = 'inactive',
  pending = 'pending',
  active = 'active',
  none = 'none',
}

export enum AddressType {
  physical = 'physical',
  mailTo = 'mail-to',
  billTo = 'bill-to',
  other = 'other',
}

export enum CustomerLocationAddressType {
  physical = 'physical',
  shipping = 'shipping',
  billing = 'billing',
}

export enum CustomerLocationGlobalLocationNumberStatus {
  PENDING = 'PENDING',
  NOT_FOUND = 'NOT FOUND',
  INCOMPLETE = 'INCOMPLETE',
  REJECTED = 'REJECTED',
  CONFIRMED_ROUTING = 'CONFIRMED ROUTING',
  CONFIRMED_ASSOCIATED = 'CONFIRMED ASSOCIATED',
}

export enum ContactType {
  phone = 'phone',
  fax = 'fax',
  email = 'email',
  cell = 'cell',
}

export enum VerifiedTradingPartnerContactType {
  office = 'office',
  mobile = 'mobile',
  fax = 'fax',
  email = 'email',
  other = 'other',
}

export enum IncidentReportType {
  initial = 'initial',
  followup = 'followup',
  terminate = 'terminate',
}

export enum IncidentClassification {
  counterfeit = 'counterfeit',
  diverted = 'diverted',
  stolen = 'stolen',
  intentionalAdulteration = 'intentional adulteration',
  unfitForDistribution = 'unfit for distribution',
  fraudulentTransaction = 'fraudulentTransaction',
}

export enum IncidentDrugUse {
  humanUse = 'human use',
  other = 'other',
}

export enum IncidentDrugDescription {
  finishedPrescriptionDrug = 'finished prescription drug',
  vaccine = 'vaccine',
  plasmaDerivative = 'plasma derivative',
  allergenic = 'allergenic',
  multiple = 'multiple',
}

export enum IncidentDosageForm {
  tablet = 'tablet',
  capsule = 'capsule',
  sublingual = 'sublingual',
  aerosol = 'aerosol',
  oralLiquid = 'oral liquid',
  injectable = 'injectable',
  topical = 'topical',
  suppository = 'suppository',
  other = 'other',
  multiple = 'multiple',
}

export enum IncidentCompanyCategory {
  manufacturer = 'manufacturer',
  wholesaleDistributor = 'wholesale distributor',
  dispenser = 'dispenser (pharmacy)',
  repackager = 'repackager',
}

export enum GLNDisposition {
  shipTo = 'SHIP TO',
  billTo = 'BILL TO',
  both = 'BOTH',
}

export enum FastspringProductName {
  dscsaSOPCreation = 'dscsa-sop-creation',
  dscsaSOPs = 'dscsa-sops',
  medtraxTrainingSession = 'medtrax-training-session',
  trainingSession1Hour = 'training-session-1-hour',
}

export enum FastspringSubscriptionName {
  additionalUserMMCAP = 'additional-user-mmcap',
  additionalUserMonthly = 'additional-user-monthly',
  medtraxBasicService = 'medtrax-basic-service',
  medtraxBasicServiceAnnual = 'medtrax-basic-service-annual',
  medtraxEnterpriseService = 'medtrax-enterprise-service',
  medtraxEnterpriseServiceAnnual = 'medtrax-enterprise-service-annual',
  medtraxEssentialsService = 'medtrax-essentials-service',
  medtraxEssentialsServiceAnnual = 'medtrax-essentials-service-annual',
  medtraxMMCAPService = 'medtrax-mmcap-service',
  medtraxPlusService = 'medtrax-plus-service',
  medtraxPlusServiceAnnual = 'medtrax-plus-service-annual',
  nracAlerts = 'nrac-alerts',
  nracMonthlySubscription = 'nrac-monthly-subscription',
  medtraxPremierService = 'medtrax-premier-service',
  additionalUserPremier = 'additional-user-premier',
}

export enum FastspringUnlimitedUserItems {
  medtraxEnterpriseService = FastspringSubscriptionName.medtraxEnterpriseService,
  medtraxEnterpriseServiceAnnual = FastspringSubscriptionName.medtraxEnterpriseServiceAnnual,
}

export const FastspringUnlimitedUserItemsArray = Object.freeze(
  Object.values(FastspringUnlimitedUserItems)
) as string[];

export const RecoveryUserItemsArrayBasicOrUltimate = Object.freeze([
  FastspringSubscriptionName.medtraxBasicService,
  FastspringSubscriptionName.medtraxEnterpriseService,
]) as string[];

export enum FastspringUserCountItems {
  additionalUserMMCAP = FastspringSubscriptionName.additionalUserMMCAP,
  additionalUserMonthly = FastspringSubscriptionName.additionalUserMonthly,
  medtraxBasicService = FastspringSubscriptionName.medtraxBasicService,
  medtraxBasicServiceAnnual = FastspringSubscriptionName.medtraxBasicServiceAnnual,
  medtraxEssentialsService = FastspringSubscriptionName.medtraxEssentialsService,
  medtraxEssentialsServiceAnnual = FastspringSubscriptionName.medtraxEssentialsServiceAnnual,
  medtraxMMCAPService = FastspringSubscriptionName.medtraxMMCAPService,
  medtraxPlusService = FastspringSubscriptionName.medtraxPlusService,
  medtraxPlusServiceAnnual = FastspringSubscriptionName.medtraxPlusServiceAnnual,
  medtraxPremierService = FastspringSubscriptionName.medtraxPremierService,
  additionalUserPremier = FastspringSubscriptionName.additionalUserPremier,
}

export enum GeneralSalesItems {
  additionalUserMonthly = FastspringSubscriptionName.additionalUserMonthly,
  dscsaSOPs = FastspringProductName.dscsaSOPs,
  medtraxBasicService = FastspringSubscriptionName.medtraxBasicService,
  medtraxEnterpriseService = FastspringSubscriptionName.medtraxEnterpriseService,
  medtraxTrainingSession = FastspringProductName.medtraxTrainingSession,
  nracMonthlySubscription = FastspringSubscriptionName.nracMonthlySubscription,
}

export const GeneralSalesItemsAsArray = Object.freeze(
  Object.values(GeneralSalesItems)
) as string[];

export enum MMCAPSalesItems {
  medtraxMMCAPService = FastspringSubscriptionName.medtraxMMCAPService,
  additionalUserMMCAP = FastspringSubscriptionName.additionalUserMMCAP,
}

export enum SharedBuyingGroupItems {
  dscsaSOPCreation = FastspringProductName.dscsaSOPCreation,
  nracAlerts = FastspringSubscriptionName.nracAlerts,
  trainingSession1Hour = FastspringProductName.trainingSession1Hour,
}

export enum PremierSalesItems {
  medtraxPremierService = FastspringSubscriptionName.medtraxPremierService,
  additionalUserPremier = FastspringSubscriptionName.additionalUserPremier,
}

export const MMCAPSalesItemsAsArray = Object.freeze([
  ...Object.values(MMCAPSalesItems),
  ...Object.values(SharedBuyingGroupItems),
]) as readonly string[];

export const PremierSalesItemsAsArray = Object.freeze([
  ...Object.values(PremierSalesItems),
  ...Object.values(SharedBuyingGroupItems),
]) as readonly string[];

export enum FSSubscriptionState {
  active = 'active',
  canceled = 'canceled',
}

export enum DocumentExceptionErrorTypeEnum {
  INVALID_FILE_EXTENSION_ERROR = 'INVALID_FILE_EXTENSION_ERROR',
  EMPTY_FILE_ERROR = 'EMPTY_FILE_ERROR',
  MALFORMED_EPCIS_XML_ERROR = 'MALFORMED_EPCIS_XML_ERROR',
  STANDARD_BUSINESS_DOCUMENT_HEADER_ERROR = 'STANDARD_BUSINESS_DOCUMENT_HEADER_ERROR',
  HEADER_HEADER_VERSION_ERROR = 'HEADER_HEADER_VERSION_ERROR',
  HEADER_RECEIVER_SGLN_ERROR = 'HEADER_RECEIVER_SGLN_ERROR',
  HEADER_SENDER_ERROR = 'HEADER_SENDER_ERROR',
  HEADER_DOCUMENT_IDENTIFICATION_ERROR = 'HEADER_DOCUMENT_IDENTIFICATION_ERROR',
  HEADER_DOCUMENT_IDENTIFICATION_TYPE_ERROR = 'HEADER_DOCUMENT_IDENTIFICATION_TYPE_ERROR',
  HEADER_DOCUMENT_IDENTIFICATION_CREATION_DATE_AND_TIME_ERROR = 'HEADER_DOCUMENT_IDENTIFICATION_CREATION_DATE_AND_TIME_ERROR',
  HEADER_DOCUMENT_IDENTIFICATION_INSTANCE_IDENTIFIER_ERROR = 'HEADER_DOCUMENT_IDENTIFICATION_INSTANCE_IDENTIFIER_ERROR',
  LOCATION_VOCABULARY_ERROR = 'LOCATION_VOCABULARY_ERROR',
  MED_VOCABULARY_ERROR = 'MED_VOCABULARY_ERROR',
  MED_VOCABULARY_MISSING_NDC_ERROR = 'MED_VOCABULARY_MISSING_NDC_ERROR',
  MED_VOCABULARY_MALFORMED_NDC_ERROR = 'MED_VOCABULARY_MALFORMED_NDC_ERROR',
  EVENT_MEDS_ERROR = 'EVENT_MEDS_ERROR',
  EVENT_LIST_ERROR = 'EVENT_LIST_ERROR',
  EVENT_LIST_EVENT_TIME_ERROR = 'EVENT_LIST_EVENT_TIME_ERROR',
  EVENT_LIST_EVENT_TIME_ZONE_OFFSET_ERROR = 'EVENT_LIST_EVENT_TIME_ZONE_OFFSET_ERROR',
  EVENT_LIST_ACTION_ERROR = 'EVENT_LIST_ACTION_ERROR',
  EVENT_LIST_BIZ_STEP_ERROR = 'EVENT_LIST_BIZ_STEP_ERROR',
  EVENT_LIST_DISPOSITION_ERROR = 'EVENT_LIST_DISPOSITION_ERROR',
  EVENT_LIST_EPC_LIST_ERROR = 'EVENT_LIST_EPC_LIST_ERROR',
  EVENT_LIST_READ_POINT_ERROR = 'EVENT_LIST_READ_POINT_ERROR',
  EVENT_LIST_BIZ_TRANSACTION_LIST_ERROR = 'EVENT_LIST_BIZ_TRANSACTION_LIST_ERROR',
  EVENT_LIST_EXTENSION_ERROR = 'EVENT_LIST_EXTENSION_ERROR',
  EVENT_LIST_SOURCE_LIST_ERROR = 'EVENT_LIST_SOURCE_LIST_ERROR',
  EVENT_LIST_DESTINATION_ERROR = 'EVENT_LIST_DESTINATION_ERROR',
  EVENT_LIST_PARENT_ID_ERROR = 'EVENT_LIST_PARENT_ID_ERROR',
  AGGREGATION_EVENT_ONE_OF_ERROR = 'AGGREGATION_EVENT_ONE_OF_ERROR',
  TRANSACTION_EVENT_ONE_OF_ERROR = 'TRANSACTION_EVENT_ONE_OF_ERROR',
  OBJECT_EVENT_ONE_OF_ERROR = 'OBJECT_EVENT_ONE_OF_ERROR',
  UNKNOWN_LOCATION_ERROR = 'UNKNOWN_LOCATION_ERROR',
  UNKNOWN_MED_ERROR = 'UNKNOWN_MED_ERROR',
  INVALID_EVENT_READ_POINT_ERROR = 'INVALID_EVENT_READ_POINT_ERROR',
  UNKNOWN_ADD_EPC_ERROR = 'UNKNOWN_ADD_EPC_ERROR',
  UNKNOWN_SHIPPING_EPC_ERROR = 'UNKNOWN_SHIPPING_EPC_ERROR',
  SHIPPED_EPC_ARE_NOT_PARENT_OR_DEFINED_ERROR = 'SHIPPED_EPC_ARE_NOT_PARENT_OR_DEFINED_ERROR',
  MULTIPLE_DESTINATION_GLNS = 'MULTIPLE_DESTINATION_GLNS',
  UNKNOWN_PARENT_EPC_ERROR = 'UNKNOWN_PARENT_EPC_ERROR',
  ALL_MEDS_NOT_SHIPPED_ERROR = 'ALL_MEDS_NOT_SHIPPED_ERROR',
  REPLACEMENT_EPCIS_VALIDATION_ERROR = 'REPLACEMENT_EPCIS_VALIDATION_ERROR',
  SHIPPING_EVENT_ERROR = 'SHIPPING_EVENT_ERROR',
}

export enum DocumentExceptionErrorStatusEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
  Resolved = 'RESOLVED',
}

export enum OutboundDocumentStatusMethodEnum {
  as2 = 'as2',
  email = 'email',
}

export enum OutboundDocumentStatusEnum {
  queued = 'queued',
  failed = 'failed',
  incomplete = 'incomplete',
  sent = 'sent',
}

export enum UserTypeEnum {
  customer = 'customer',
  tradingPartner = 'trading partner',
}

export enum QuarantineStatusEnum {
  Quarantined = 'QUARANTINED',
  Received = 'RECEIVED',
  Illegitimate = 'ILLEGITIMATE',
  Returned = 'RETURNED',
  Unquarantined = 'UNQUARANTINED',
}

export enum QuarantineStatusAction {
  Scan = 'SCAN',
  Manual = 'MANUAL',
  Batch = 'BATCH',
}
